var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app flex-row align-items-center" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                { attrs: { md: "8" } },
                [
                  _vm.isWelcomeMessage
                    ? _c(
                        "b-card",
                        {
                          staticClass: "bg-grey-900 p-4 m-0",
                          attrs: { "no-body": "" },
                        },
                        [
                          _c("div", [
                            _c("p", [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.welcomeMessage),
                                },
                              }),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "b-card-group",
                    [
                      _c(
                        "b-card",
                        { staticClass: "p-4", attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-card-body",
                            [
                              _c("validation-observer", {
                                attrs: { tag: "form" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function ({ passes }) {
                                      return [
                                        _c(
                                          "b-form",
                                          {
                                            on: {
                                              submit: function ($event) {
                                                $event.preventDefault()
                                                $event.stopPropagation()
                                                return passes(_vm.login)
                                              },
                                            },
                                          },
                                          [
                                            _c("h1", [
                                              _vm._v(
                                                _vm._s(_vm.$t("message.login"))
                                              ),
                                            ]),
                                            _c(
                                              "p",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.login_desc")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-validated-input-group-form-input",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.showLoginForm,
                                                    expression: "showLoginForm",
                                                  },
                                                ],
                                                attrs: {
                                                  id: "username",
                                                  label:
                                                    _vm.$t("message.username"),
                                                  "input-group-size": "mb-3",
                                                  rules: "required",
                                                  mode: "passive",
                                                  icon: "icon-user",
                                                  type: "text",
                                                  autocomplete:
                                                    "username email",
                                                  autofocus: "true",
                                                  lazy: "true",
                                                },
                                                model: {
                                                  value: _vm.input.username,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.input,
                                                      "username",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "input.username",
                                                },
                                              }
                                            ),
                                            _c(
                                              "b-validated-input-group-form-input",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.showLoginForm,
                                                    expression: "showLoginForm",
                                                  },
                                                ],
                                                attrs: {
                                                  name: "password",
                                                  label:
                                                    _vm.$t("message.password"),
                                                  "input-group-size": "mb-3",
                                                  rules: "required",
                                                  mode: "passive",
                                                  icon: "icon-lock",
                                                  type: "password",
                                                  autcomplete:
                                                    "currentpassword",
                                                  lazy: "true",
                                                },
                                                model: {
                                                  value: _vm.input.password,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.input,
                                                      "password",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "input.password",
                                                },
                                              }
                                            ),
                                            _c(
                                              "b-row",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "1rem",
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.showLoginForm,
                                                        expression:
                                                          "showLoginForm",
                                                      },
                                                    ],
                                                    attrs: { cols: "6" },
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass: "px-4",
                                                        attrs: {
                                                          variant: "primary",
                                                          type: "submit",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.login"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.oidcAvailable,
                                                        expression:
                                                          "oidcAvailable",
                                                      },
                                                    ],
                                                    attrs: { cols: "6" },
                                                  },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        style: {
                                                          float:
                                                            _vm.showLoginForm
                                                              ? "right"
                                                              : "none",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.oidcLogin()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm.oidcCheckLoginButtonTextSetted()
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.oidcLoginButtonText()
                                                                )
                                                              ),
                                                            ])
                                                          : _c("img", {
                                                              attrs: {
                                                                alt: "OpenID Logo",
                                                                src: require("@/assets/img/openid-logo.svg"),
                                                                width: "60px",
                                                              },
                                                            }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-link",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.oidcAvailable &&
                                                      !_vm.showLoginForm,
                                                    expression:
                                                      "oidcAvailable && !showLoginForm",
                                                  },
                                                ],
                                                on: {
                                                  click: function ($event) {
                                                    _vm.showLoginForm = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.login_more_options"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-card",
                        {
                          staticClass:
                            "text-white bg-grey-900 py-5 d-md-down-none",
                          staticStyle: { width: "44%" },
                          attrs: { "no-body": "" },
                        },
                        [
                          _c("b-card-body", { staticClass: "text-center" }, [
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/brand/dt-logo-vertical-white-text.svg"),
                                  width: "100%",
                                },
                              }),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("informational-modal", { attrs: { message: _vm.loginError } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }